import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import App from '@/presentation/App.vue';
import { router } from '@/presentation/router';
import '@mdi/font/css/materialdesignicons.css';
import '@/presentation/styles/main.css';
import '@/presentation/styles/tokens.css';
import '@/presentation/styles/raya-ui.css';
import '@/presentation/styles/admin.css';
import { useUiPreferences } from '@/presentation/composables/useUiPreferences';

useUiPreferences().restore();

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(VueQueryPlugin);

app.mount('#app');
